export default "__VITE_ASSET__KsLf41z3__"